import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        /*document.cookie = 'cow-to-find=0';
        document.cookie = 'cow-home=0';
        document.cookie = 'cow-event=0';
        document.cookie = 'cow-product=0';*/

        let cowToFind = 0;
        const overlay = document.querySelector('.c-overlay');

        if (this.getCookie("cow-start") == null) {
            let overlay = document.querySelector('.js-overlay-cow');
            overlay.classList.add('is-visible');
        }

        if (this.getCookie("cow-home") == 1) {
            cowToFind += 1;
            try {
                const cowHome = document.querySelector('[data-id=cow-home]');
                cowHome.classList.add('is-found');
            } catch(err) {

            }
        }

        if (this.getCookie("cow-event") == 1) {
            cowToFind += 1;
            try {
                const cowEvent = document.querySelector('[data-id=cow-event]');
                cowEvent.classList.add('is-found');
            } catch(err) {

            }
        }

        if (this.getCookie("cow-product") == 1) {
            cowToFind += 1;
            try{
                const cowProduct = document.querySelector('[data-id=cow-product]');
                cowProduct.classList.add('is-found');
            } catch(err) {

            }
        }

        [...document.querySelectorAll('.c-overlay__close, .c-button')].forEach(el => {
            el.addEventListener('click', () => {
                document.cookie = `cow-start=1`;
                overlay.classList.remove('is-visible');
            });
        });

        document.querySelector('.c-cow-to-find').addEventListener('click', (e) => {
            overlay.classList.add('is-visible');
            e.currentTarget.classList.add('is-found');

            if (e.currentTarget.dataset.id === 'cow-home') {
                document.cookie = `cow-home=1`;
                cowToFind += 1;
            } else if (e.currentTarget.dataset.id === 'cow-event') {
                document.cookie = `cow-event=1`;
                cowToFind += 1;
            } else if (e.currentTarget.dataset.id === 'cow-product') {
                document.cookie = `cow-product=1`;
                cowToFind += 1;
            }
            if(cowToFind == 1){
                document.querySelector('.c-overlay__text__content').innerHTML = '<h2>Trouvé!</h2><p>Tu es VACHE-ment fort, tu as trouvé la première place! Continue, il faut la ramener au Troupeau!</p>';
                document.querySelector('.c-overlay__button .c-button_label').innerHTML = 'Continuer à chercher';
            } else if(cowToFind == 2){
                document.querySelector('.c-overlay__text__content').innerHTML = '<h2>Trouvé!</h2><p>Ho la vache! Tu as trouvé la deuxième! Plus qu’une place, vite!</p>';
                document.querySelector('.c-overlay__button .c-button_label').innerHTML = 'Continuer à chercher';
            } else if(cowToFind == 3){
                let form = document.querySelector('.js-form-vache');
                form.classList.add('is-visible');
                document.querySelector('.c-overlay__text__content').innerHTML = '<h2>Bravo!</h2><p>Tu as trouvé les 3 places! Inscris ton courriel pour recevoir ton code promo de 10 %. Tu auras aussi une chance d’être sélectionné.e pour recevoir une carte cadeau de 50 $!</p>';
                document.querySelector('.c-overlay__button').remove();
            }
            
            document.querySelector('.c-overlay__counter span').innerHTML = cowToFind;
        });
    }

    getCookie(name) {
        // Split cookie string and get all individual name=value pairs in an array
        var cookieArr = document.cookie.split(";");
        
        // Loop through the array elements
        for(var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i].split("=");
            
            /* Removing whitespace at the beginning of the cookie name
            and compare it with the given string */
            if(name == cookiePair[0].trim()) {
                // Decode the cookie value and return
                return decodeURIComponent(cookiePair[1]);
            }
        }
        
        // Return null if not found
        return null;
    }
}
